/* Horizontal scroll helper for tab-row headers (drag + wheel) */
(function () {
  const SELECTOR =
    '.tab-heading-container.horizontal__tab-header,' +
    ' .product-tabs__header.overflow-x-scroll-mb';
  const DRAG_THRESHOLD = 5;

  function setOverflowState(el) {
    if (!el) return;
    const overflowing = el.scrollWidth > el.clientWidth + 1;
    el.classList.toggle('is-overflowing', overflowing);
  }

  function enableHorizontalScroll(el) {
    if (!el || el.dataset.tsScrollInit === '1') return;
    el.dataset.tsScrollInit = '1';

    el.style.cursor = 'grab';

    setOverflowState(el);

    let isDown = false;
    let dragging = false;
    let startX = 0;
    let startScroll = 0;
    let suppressClick = false;

    const onPointerDown = (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      isDown = true;
      dragging = false;
      startX = e.clientX;
      startScroll = el.scrollLeft;
      el.style.cursor = 'grabbing';
    };

    const onPointerMove = (e) => {
      if (!isDown) return;
      const dx = e.clientX - startX;
      if (!dragging && Math.abs(dx) > DRAG_THRESHOLD) {
        dragging = true;
      }
      if (dragging) {
        el.scrollLeft = startScroll - dx;
        e.preventDefault();
      }
    };

    const onPointerUp = () => {
      if (!isDown) return;
      isDown = false;
      el.style.cursor = 'grab';
      // Only swallow the click that follows a real drag
      suppressClick = dragging;
      dragging = false;
    };

    el.addEventListener('pointerdown', onPointerDown);
    // Track move/up on the document so we don't lose the pointer when leaving the bar
    document.addEventListener('pointermove', onPointerMove, { passive: false });
    document.addEventListener('pointerup', onPointerUp);
    document.addEventListener('pointercancel', onPointerUp);

    // Suppress only the click that happens right after a drag (capture phase)
    el.addEventListener('click', (e) => {
      if (suppressClick) {
        e.preventDefault();
        e.stopPropagation();
        suppressClick = false;
      }
    }, true);

    // Prevent native image dragging from hijacking the gesture
    el.querySelectorAll('img').forEach((img) => {
      img.setAttribute('draggable', 'false');
    });

    // Convert vertical wheel to horizontal scroll when the bar overflows
    el.addEventListener('wheel', (e) => {
      const canScrollX = el.scrollWidth > el.clientWidth + 1;
      if (!canScrollX) return;
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        el.scrollLeft += e.deltaY;
        e.preventDefault();
      }
    }, { passive: false });

    // Keep alignment in sync with overflow state (resize / content changes)
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(() => setOverflowState(el));
      ro.observe(el);
    } else {
      window.addEventListener('resize', () => setOverflowState(el));
    }

    if (window.MutationObserver) {
      const mo = new MutationObserver(() => setOverflowState(el));
      mo.observe(el, { childList: true, subtree: true, characterData: true });
    }
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(enableHorizontalScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:block:select', (e) => initAll(e.target));
})();